import SkeletonElement from "./SkeletonElement";

export type SkeletonListProps = { rows: number };

export default function SkeletonList({ rows }: SkeletonListProps) {
  return (
    <div className="space-y-4">
      {Array.from({ length: rows }).map((_, index) => {
        const width = Math.random() * 25 + 75;
        return <SkeletonElement key={index} height="h-8" width={width} data-testid="skeleton-row" />;
      })}
    </div>
  );
}
